import { isSameDay as isSameDayFns } from 'date-fns';

export default function isSameDay(date: Date, dateToCompareTo: Date): boolean {
  return isSameDayFns(date, dateToCompareTo);
}
